<template>
<div class="chapter">
<div class="inner_page">
<a id="pagev">
<h1 class="tocheading">Contents</h1>
</a><h2 class="toc"><a id="pagev"></a><a href="#/xhtml/06_Maps">List of Maps and Plates</a></h2>
<h2 class="toc"><a href="#/xhtml/07_Introduction">Introduction</a></h2>
<h2 class="toc"><a href="#/xhtml/08_Chronology">Chronology</a></h2>
<h2 class="tocp"><a href="#/xhtml/09_Part_one">PART ONE: THE COMING OF WAR</a></h2>
<h3 class="toc"><a href="#/xhtml/10_Chapter_01">1. Problems with the Pragmatica Sanctio</a></h3>
<h3 class="toc"><span href="#/xhtml/11_Chapter_02" title="Link target outside of Sample">2. The Art of War in the Eighteenth Century</span></h3>
<h3 class="toc"><span href="#/xhtml/12_Chapter_03" title="Link target outside of Sample">3. The German Marshal –Maurice Saxe</span></h3>
<h3 class="toc"><span href="#/xhtml/13_Chapter_04" title="Link target outside of Sample">4. Billy the Martial Boy – Cumberland, the last Captain General</span></h3>
<h3 class="toc"><span href="#/xhtml/14_Chapter_05" title="Link target outside of Sample">5. Gallant Lieutenants – Löwendhal, Waldeck, Königseggand Ligonier</span></h3>
<h2 class="tocp"><span href="#/xhtml/15_Part_two" title="Link target outside of Sample">PART TWO: A MOST BLOODY BATTLE</span></h2>
<h3 class="toc"><span href="#/xhtml/16_Chapter_06" title="Link target outside of Sample">6. Tournai –the Great Fortresson the Scheldt</span></h3>
<h3 class="toc"><span href="#/xhtml/17_Chapter_07" title="Link target outside of Sample">7. A Breaking-in Battle</span></h3>
<h3 class="toc"><span href="#/xhtml/18_Chapter_08" title="Link target outside of Sample">8.The Infernal Column</span></h3>
<h3 class="toc"><span href="#/xhtml/19_Chapter_09" title="Link target outside of Sample">9. Luscious Sweets of Success, Bitter Fruits of Failure</span></h3>
<h2 class="tocp"><span href="#/xhtml/20_Part_three" title="Link target outside of Sample">PART THREE: HARD ROADS TOWARDS PEACE</span></h2>
<h2 class="toc"><span href="#/xhtml/21_Chapter_10" title="Link target outside of Sample">10. The Jacobite Distraction</span></h2>
<h2 class="toc"><span href="#/xhtml/22_Chapter_11" title="Link target outside of Sample">11. The Treaty of Aix-la-Chapelle</span></h2>
<h2 class="toca"><span href="#/xhtml/23_Appendix_01" title="Link target outside of Sample">Appendix 1.<span class="toc-sp">Orders of Battle of the Armies at Fontenoy</span></span></h2>
<h2 class="toca"><span href="#/xhtml/24_Appendix_02" title="Link target outside of Sample">Appendix 2.<span class="toc-sp">The Deposition of Brigadier General Richard Ingoldsby</span></span></h2>
<h2 class="toca"><span href="#/xhtml/25_Appendix_03" title="Link target outside of Sample">Appendix 3.<span class="toc-sp">British Casualties at Fontenoy</span></span></h2>
<h2 class="toc"><span href="#/xhtml/26_Footnote" title="Link target outside of Sample">Notes</span></h2>
<h2 class="toc"><span href="#/xhtml/27_Bibliography" title="Link target outside of Sample">Bibliography</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Toc.vue?56ae8b4b